import { InjectionToken } from '@angular/core';
import { Config } from 'src/config/config.interface';

export const CONFIG = new InjectionToken<Config>('config', {
  providedIn: 'root',
  factory: () => window.BD_CONFIG,
});
